import { customSWRConfig } from '../../model/types';
import { getTicketStatus } from '../../utils/ticketHelper';
import useCurrentTicket from './useCurrentTicket';

export default function useCurrentTicketStatus(config: customSWRConfig = {}) {
    const { data } = useCurrentTicket(config);

    return getTicketStatus(data);
}
